import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import TermsAndConditions from "../pages/termsandcondition";
import ThankYou from "../pages/thankyou";
import GiftThankYou from "../pages/giftThankYou";
import Privacy from "../pages/privacy";
import Redirect from "../pages/redirect";
import PaymentCancel from "../pages/paymentcancelled";
import CheckInService from "../pages/checkinservice";
import SpecialEvents from "../pages/specialevents";

const CommonRoute = () => {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/terms-conditions" />} />
      <Route path="/terms-conditions" element={<TermsAndConditions />} />
      <Route path="/privacy-policy" element={<Privacy />} />
      <Route path="/special-events" element={<SpecialEvents />} />
     <Route path="/starter-volunteer-onboarding" element={<Redirect />} />
     <Route path="/thank-you-page" element={<ThankYou />} />
     <Route path="/gift-thank-you" element={<GiftThankYou />} />
     <Route path="/payment-cancelled" element={<PaymentCancel />} />
   
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
};
export default CommonRoute;
